import VueI18n from 'vue-i18n'
import Vue from 'vue'
import languageDe from './language_de.json'
import languageEn from './language_en.json'
import { localize } from 'vee-validate'

Vue.use(VueI18n)

const messages = {
  de: languageDe,
  en: languageEn
}

const lang = getParameterByName('lang') || 'en'

const custom = {}
custom['item-no'] = {
  required: messages[lang]['hs.att-dashboard.item-no-required']
}
custom['serial-no'] = {
  required: messages[lang]['hs.att-dashboard.serial-no-required']
}
const dict = {
  fields: custom
}

localize(lang, dict)

// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: getParameterByName('lang') || 'en', // set locale
  messages // set locale messages
})

Object.defineProperty(Vue.prototype, '$locale', {
  get: function () {
    return i18n.locale
  },
  set: function (locale) {
    i18n.locale = locale
  }
})

function getParameterByName (name, url) {
  if (!url) {
    url = window.location.href
  }
  name = name.replace(/[[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) {
    return null
  }
  if (!results[2]) {
    return ''
  }
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
